import { Fragment } from "react";

import { formatDate } from "simplydo/core/dates";
import { Icon } from "simplydo/react/ui";

import type { CompanyBlog as CompanyBlogType } from "components/innointel/types";

import {
  InfoBoxWidget,
  InfoBoxWidgetTitleArea,
  InfoContainer,
  InfoItem,
  KeyFactLink,
} from "../Styles";

type CompanyBlogProps = { blogs: CompanyBlogType[] };

const CompanyBlog = ({ blogs }: CompanyBlogProps) => {
  if (!blogs.length) return null;
  return (
    <InfoBoxWidget>
      <InfoBoxWidgetTitleArea>
        <Icon name="newspaper" />
        <div>
          <h3>Blogs</h3>
          <span>{blogs.length} found</span>
        </div>
      </InfoBoxWidgetTitleArea>
      {blogs.map((blog, blogIndex) => (
        <Fragment key={blog.title ?? blog.link ?? blogIndex}>
          <h1>{blog.title}</h1>
          <InfoContainer $wrapped>
            {(blog.entries ?? []).map((blogPost, entryIndex) => (
              <InfoItem
                key={blogPost.link ?? `${blogPost.title}-${entryIndex}`}
                href={blogPost.link}
              >
                <KeyFactLink
                  title={blogPost.title ?? "Untitled"}
                  fact={
                    blogPost.publishedAt
                      ? `Published: ${formatDate(blogPost.publishedAt, "yyyy-MM-dd HH:mm")}`
                      : ""
                  }
                  image={blogPost.imageUrl}
                  url={blogPost.link}
                />
              </InfoItem>
            ))}
          </InfoContainer>
        </Fragment>
      ))}
    </InfoBoxWidget>
  );
};

export default CompanyBlog;
